<!-- 파트너 의뢰 -->
<template>
  <div>
    <admin-box-item title="파트너 의뢰" :useTab="false">
      <div class="columns is-multiline">
        <div class="column is-full">
          <admin-form-item label="파트너*">
            <lp-adm-drop-input ref="adminput"
                               :data.sync="partners"
                               :selectVal="partnerName"
                               @onSelect="res => value.requestItem.partner_id = res.value"
                               placeholder="검색 후 선택"
                               width="250px"
                               listAlign="left"
                               style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>
          </admin-form-item>
        </div>

        <div class="column is-full" v-if="errMsg">
          <span class="has-text-danger">{{ errMsg }}</span>
        </div>

        <div class="column is-full">
          <textarea class="textarea" rows="3" cols="10" v-model="value.requestItem.note"></textarea>
        </div>

        <div class="column is-full">
          <old-input-file :files.sync="value.requestItem.files" @remove="idx=>removeIndex(value.requestItem.files, idx)"></old-input-file>
        </div>
      </div>

      <div class="btn-group-justify-end">
        <button class="button is-light" @click="cancelModal">취소</button>
        <button class="button is-primary" @click="saveRequestPartner">확인</button>
      </div>
    </admin-box-item>
  </div>
</template>

<script>

  import AdminFormItem from "../admin/AdminFormItem";
  import LpAdmDropInput from "../common/LpAdmDropInput";
  import InputFile from "../common/InputFile";
  import OldInputFile from "../common/OldInputFile";

  export default {
    props: ['data'],
    components: {
      OldInputFile,
      InputFile,
      LpAdmDropInput,
      AdminFormItem
    },
    data() {
      return {
        value: {
          requestItem: {
            files:'',
            note:'',
            partner_id:'',
            request_id:''
          }
        },
        partners:[],
        errMsg:''
      }
    },
    computed: {
      partnerName(){
        let partner_id;
        if(this.value.requestItem){
          partner_id = this.value.requestItem.partner_id;
        }

        let partner = find(this.partners, 'value', partner_id);
        if(partner !== undefined)
          return partner.name;
        else
          return '';
      }
    },
    created() {
      this.value = this.data;
      if(this.$store.getters.mode==='admin') {
        this.$axios.get('admin/partner/simple').then(res => {
          this.partners = res.data;
        })
      }
    },
    watch: {
      data(n) {
        if (n) {
          this.value = n;
        }
      }
    },
    methods: {
      cancelModal(){
        this.$store.commit('cancelModal');
      },
      //의뢰서 저장
      saveRequestPartner(){
        if(this.value.requestItem.partner_id===''){
          this.errMsg = '파트너를 선택해주세요.';
        }
        else{
          this.errMsg = '';
        }

        if(this.errMsg!==''){
          return;
        }

        let url = this.getUrl('estimate/partner');
        this.$axios.post(url, this.value.requestItem)
          .then(res => {
            if(res.status === 200) {
              this.toast('저장되었습니다.');

              this.value = {
                requestItem: {
                  files:'',
                  note:'',
                  partner_id:'',
                  request_id:''
                }
              };
              this.$store.commit('closeModal');
              // 드롭다운리스트 초기화
              this.$refs.adminput.selectedLabel = '';
            }
          }).catch(error => {
          if(error.response){
            this.toast(error.response.data.message);
          }
        });
      }
    }
  }
</script>
<style lang="stylus" type="stylus" scoped>

</style>
